import React, { useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button } from 'primereact/button';
import { Message } from 'primereact/message';
import { flagLookupsApi } from '../../api/flagSystemApi';
import usePageAccessRedirect from '../../hooks/usePageAccessRedirect';
import { positiveId } from '../../utils/flagSystem';
import AccessState from '../AccessState';
import { FlagPage, ResourceState, useRemoteResource } from './FlagSystemCommon';
import CustomerFlagSystemStatus from './CustomerFlagSystemStatus';

const AdminFlagSystem = () => {
  const { customerId } = useParams();
  const navigate = useNavigate();
  const { accessIssue, handleAccessError } = usePageAccessRedirect({ deniedRedirectTo: '/customers' });
  const load = useCallback(() => flagLookupsApi.adminCustomer(Number(customerId)), [customerId]);
  const resource = useRemoteResource(positiveId(customerId) ? load : null, handleAccessError);
  if (accessIssue) return <AccessState {...accessIssue} />;
  return <FlagPage title="Flag System" actions={<Button label="Back To Customers" icon="pi pi-arrow-left" className="p-button-text" onClick={() => navigate('/customers')} />}>
    {!positiveId(customerId) ? <Message severity="error" text="Select a customer in the Customers page first." /> :
      <ResourceState resource={resource}>
        <h5>{resource.data && resource.data.name} <small>Customer {customerId}</small></h5>
        <CustomerFlagSystemStatus customerId={Number(customerId)} />
      </ResourceState>}
  </FlagPage>;
};
export default AdminFlagSystem;
